const ElementReplacer = {
  replace: function (sourceDocument, elementSelector) {
    let newElement = sourceDocument.querySelector(elementSelector);
    if (newElement) {
      let elementToReplace = document.querySelector(elementSelector);
      if (elementToReplace) {
        elementToReplace.parentNode.replaceChild(newElement, elementToReplace);
      }
    }
  },
  replaceNode: function (sourceNode, elementSelector) {
    let oldElement = document.querySelector(elementSelector);
    if (oldElement) {
      oldElement.parentNode.replaceChild(sourceNode, oldElement);
    }
  },
  insertOrReplace: function (sourceDocument, elementSelector, targetModifier) {
    let newElement = sourceDocument.querySelector(elementSelector);
    if (newElement) {
      let oldElement = document.querySelector(elementSelector);
      if (oldElement) {
        oldElement.parentNode.replaceChild(newElement, oldElement);
      } else {
        targetModifier(newElement)
      }
    }
  },
  insertOrReplaceNode: function (sourceNode, elementSelector, targetModifier) {
    let oldElement = document.querySelector(elementSelector);
    if (oldElement) {
      oldElement.parentNode.replaceChild(sourceNode, oldElement);
    } else {
      targetModifier(sourceNode)
    }
  },
  atEndOf: function (targetSelector) {
    return function (newElement) {
      let targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.appendChild(newElement)
      }
    }
  },
  after: function (targetSelector) {
    return function (newElement) {
      let targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.parentNode.insertBefore(newElement, targetElement.nextSibling);
      }
    }
  },
  afterLastOf: function (targetSelector) {
    return function (newElement) {
      let selection = document.querySelectorAll(targetSelector);
      if (selection) {
        let last = selection.length > 1 ? selection.length - 1 : 0;
        let targetElement = selection[last];
        targetElement.parentNode.insertBefore(newElement, targetElement.nextSibling);
      }
    }
  },
  replaceOrRemove: function (sourceDocument, elementSelector) {
    let newElement = sourceDocument.querySelector(elementSelector);
    if (newElement) {
      let elementToReplace = document.querySelector(elementSelector);
      if (elementToReplace) {
        elementToReplace.parentNode.replaceChild(newElement, elementToReplace);
      }
    } else {
      let elementToRemove = document.querySelector(elementSelector);
      if (elementToRemove) {
        elementToRemove.remove();
      }
    }
  }
};

export default ElementReplacer;
